/* Antioxidantech: carrusel compartido. Sin dependencias (misma técnica que .atx-carousel).
   Marcado esperado dentro de [data-atx-slider]:
     [data-atx-track]          contenedor con scroll (los hijos son las diapositivas)
     [data-dir="-1"|"1"]       flechas (opcionales)
     [data-atx-dots]           contenedor de puntos (opcional, se rellena solo) */
(function () {
  function init(wrap) {
    if (wrap.dataset.atxSliderReady === 'true') return;
    var track = wrap.querySelector('[data-atx-track]');
    if (!track) return;
    wrap.dataset.atxSliderReady = 'true';

    var arrows = wrap.querySelectorAll('[data-dir]');
    var dotsBox = wrap.querySelector('[data-atx-dots]');
    function step() {
      var slide = track.firstElementChild;
      if (!slide) return track.clientWidth;
      return slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    }

    function perView() {
      return Math.max(1, Math.round((track.clientWidth || 1) / (step() || 1)));
    }

    function pages() {
      return Math.max(1, Math.ceil(track.children.length / perView()));
    }

    function currentPage() {
      return Math.round(track.scrollLeft / (perView() * step() || 1));
    }

    function buildDots() {
      if (!dotsBox) return;
      var total = pages();
      if (dotsBox.children.length === total) return;
      dotsBox.textContent = '';
      if (total < 2) return;
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.dataset.index = i;
        b.setAttribute('aria-label', (i + 1) + ' / ' + total);
        b.addEventListener('click', function () {
          track.scrollTo({ left: Number(this.dataset.index) * perView() * step(), behavior: 'smooth' });
        });
        dotsBox.appendChild(b);
      }
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      arrows.forEach(function (btn) {
        var dir = Number(btn.dataset.dir);
        btn.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
      });
      if (dotsBox && dotsBox.children.length) {
        var idx = currentPage();
        Array.prototype.forEach.call(dotsBox.children, function (dot, i) {
          if (i === idx) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      wrap.toggleAttribute('data-no-scroll', max <= 2);
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: Number(btn.dataset.dir) * step(), behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { buildDots(); update(); });
    buildDots();
    update();
    // Las imágenes cambian el ancho al cargar: recalcula cuando terminen.
    window.addEventListener('load', function () { buildDots(); update(); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-atx-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Editor del theme: las secciones se recargan sin refrescar la página.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.atxSliderInit = initAll;
})();
